import { Button, Flex, Modal, Typography } from '@contiple/antd-ds';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

interface FreeTrialEndedAlertModalProps {
  open: boolean;
  onClose: () => void;
}

export default function FreeTrialEndedAlertModal({
  open,
  onClose,
}: FreeTrialEndedAlertModalProps) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      closable={false}
      centered
      width={360}
      title={t('dashboard.freeTrialEndedTitle')}
      styles={{
        content: { padding: 0 },
        header: { padding: '32px 32px 20px' },
        body: { padding: '0 32px' },
        footer: { padding: '24px 32px' },
      }}
      footer={
        <Flex justify="flex-end">
          <Button onClick={onClose}>{t('dashboard.freeTrialClose')}</Button>
        </Flex>
      }>
      <Flex vertical>
        <Text type="secondary" style={{ fontWeight: 500 }}>
          {t('dashboard.freeTrialEndedDesc1')}
        </Text>
        <Text type="secondary" style={{ fontWeight: 500 }}>
          {t('dashboard.freeTrialEndedDesc2')}
        </Text>
        <Text type="secondary" style={{ fontWeight: 500 }}>
          {t('dashboard.freeTrialEndedDesc3')}
        </Text>
      </Flex>
    </Modal>
  );
}
